module.exports = __webpack_public_path__ + "static/age-of-ambition-93ffcd46db9d8891d49c24d91e1207a7.jpg";